import React from 'react';
import type { V2Guard, V2Route } from '../units/types';

/** 旧 /ads/song と同じくカード未登録ロック */
const guard: V2Guard = { kind: 'card' };

/** この担当が新UIで作り直した画面の経路。作り終えたものから足す（足すまでは旧画面が枠の中に出る） */
const routes: V2Route[] = [
  { path: 'ads/song', Component: React.lazy(() => import('./SongListPage')), guard },
  { path: 'ads/song/:projectId', Component: React.lazy(() => import('./SongEditorPage')), guard },
];

export default routes;
